export const cloudCounterTabs = [
    {
        id: "software",
        title: "Jira Software",
    },
    {
        id: "scheme",
        title: "Jira Scheme",
    },
    {
        id: "management",
        title: "Jira Management",
    },
    {
        id: "inactiveresources",
        title: "Inactive Resource",
    },
];

export const cloudCounterObject = {
    software: "Jira Software",
    scheme: "Jira Scheme",
    management: "Jira Management",
    inactiveresources: "Inactive Resource",
};
